"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var CommonNavigationBarPopover_1 = require("Project/TopNavigationBar/DefaultNavigationButtons/PopoverComponents/CommonNavigationBarPopover");
var CallToAction_1 = __importDefault(require("Project/Actions/CallToActions/CallToAction"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var inversify_react_1 = require("inversify-react");
var TemplatesApiService_1 = require("Dashboard/TemplateManagementDashboard/TemplatesApiService");
function ConvertToTemplatePopoverComponent(props) {
    var _this = this;
    var action = props.action;
    var notifyUser = (0, inversify_react_1.useInjection)("notifyUser");
    var projectStore = (0, inversify_react_1.useInjection)("projectStore");
    var templatesApiService = (0, inversify_react_1.useInjection)(TemplatesApiService_1.TemplatesApiService);
    var clientUrl = (0, inversify_react_1.useInjection)("clientUrl");
    var state = (0, inversify_react_1.useInjection)("state");
    var _a = __read((0, react_1.useState)(undefined), 2), result = _a[0], setResult = _a[1];
    var cloneToTemplateCallback = (0, react_1.useCallback)(function () { return __awaiter(_this, void 0, void 0, function () {
        var response, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4, templatesApiService.createTemplate(projectStore._id)];
                case 1:
                    response = _a.sent();
                    setResult({
                        templateId: response._id,
                    });
                    return [3, 3];
                case 2:
                    e_1 = _a.sent();
                    console.error(e_1);
                    notifyUser.error("There was an error creating the template.");
                    throw e_1;
                case 3: return [2];
            }
        });
    }); }, [templatesApiService, setResult, projectStore]);
    return (react_1.default.createElement(CommonNavigationBarPopover_1.CommonNavigationBarPopover, { action: action, childClassname: "convert-to-template-popover-container", ignoreElements: [".convert-to-template-panel"], isButtonDisabled: action.disabled, buttonDisabledReason: action.disabledReason, tooltipSize: action.tooltipSize },
        react_1.default.createElement(kaleidoscope_1.Panel, { className: "convert-to-template-panel" }, !result ? (react_1.default.createElement(CallToAction_1.default, { text: "Create a template from this page, and use Tokens to personalise it.", secondaryText: "This action won't affect the current page.", image: react_1.default.createElement("img", { src: "/Assets/Images/onboarding-tokens.png" }), primaryButtonAction: cloneToTemplateCallback, primaryButtonText: "Create template", secondaryButtonAction: "https://help.qwilr.com/article/730-personalizing-qwilr-pages-with-tokens" })) : (react_1.default.createElement(CallToAction_1.default, { text: "A new template has been created and it is now ready to be edited.", image: react_1.default.createElement("img", { src: "/Assets/Images/success-tokens.png" }), primaryButtonAction: function () {
                state.go("project", { id: result.templateId });
            }, primaryButtonText: "Edit Template", secondaryButtonText: "Go to Templates Dashboard", secondaryButtonAction: "".concat(clientUrl, "/#/templates") })))));
}
exports.default = ConvertToTemplatePopoverComponent;
